export interface MediaDebugStats {
  source: "LIVE" | "PLAYBACK" | "PLAYBACK MSE";
  codec?: string | null;
  width?: number | null;
  height?: number | null;
  fps?: number | null;
  bitrate?: number | null;
  lostPackets?: number | null;
  droppedFrames?: number | null;
}

export function MediaDebugOverlay({ stats }: { stats: MediaDebugStats }) {
  const resolution = stats.width && stats.height ? `${stats.width}×${stats.height}` : "--";
  return <div className="media-debug-overlay" aria-label="Media debug information">
    <span>{stats.source} · CODEC {stats.codec || "--"}</span>
    <span>RES {resolution} · FPS {formatFps(stats.fps)}</span>
    <span>BITRATE {formatBitrate(stats.bitrate)}{stats.lostPackets !== undefined && stats.lostPackets !== null ? ` · LOST ${stats.lostPackets}` : ""}{stats.droppedFrames !== undefined && stats.droppedFrames !== null ? ` · DROPPED ${stats.droppedFrames}` : ""}</span>
  </div>;
}

function formatFps(value: number | null | undefined): string {
  return value !== null && value !== undefined && Number.isFinite(value) ? value.toFixed(1) : "--";
}

function formatBitrate(value: number | null | undefined): string {
  if (value === null || value === undefined || !Number.isFinite(value) || value < 0) return "--";
  if (value >= 1_000_000) return `${(value / 1_000_000).toFixed(2)} Mbps`;
  if (value >= 1_000) return `${(value / 1_000).toFixed(0)} kbps`;
  return `${value.toFixed(0)} bps`;
}
